define([
	"require",
	"jquery",
	"Mustache",
	"wcs.context",
	'shared.main.screen'
], function(require, $, Mustache, ctx, screenSize){

var findInStoreData,
	findInStoreDataLocationType,
	FindInStoreConfig = {},
	$altColors;

var init = function(data, locationType){
	findInStoreData = data;
	findInStoreDataLocationType = locationType;
	
	if(findInStoreData.response){
		return;
	}

	$('.store-results-list').empty();	
	FindInStoreConfig.formLocation = WCS_CONFIG.get('PDP::pdpInstoreAvailabilityMode');
	FindInStoreConfig.altColorsEnabled = WCS_CONFIG.get('PDP::pdpInstoreAltColorEnabled');
	FindInStoreConfig.mobileResultsCollapsed = WCS_CONFIG.get('PDP::pdpInstoreMobileResultsCollapsed');
	
	_renderListInPopup();	
	
};

function _renderAltColors(findInStoreData){
	require(['wcs.find-in-store-alt-colors'], function(altColors){
		altColors.init(findInStoreData);
	});
}

var _renderListInPopup = ( function(){

	var self = {},
		renderedDetails,
		$visibleStores,
		$hiddenStores,
		numVisibleStores,
		templateName;

	self.render = function(){
	if(WCS_CONFIG.get("BOPIS::bopisEnabled")) {
		templateName = "html.find-in-store.popup-store-details-bopis";
	}
	else{
		templateName = "html.find-in-store.popup-store-details";
	}
		require([templateName, "wcs.find-in-store-util"], function(detailsTemplate, util){
			renderedDetails = Mustache.render(detailsTemplate, findInStoreData);
			$('.store-results-list').html(renderedDetails);
			self._setSelectedStore();
			self._showVisibleCount();
			if(WCS_CONFIG.get("BOPIS::bopisEnabled") || WCS_CONFIG.get("PDP::w2gifilterOOSStores")) {
				self._showStoreCheckBox();
				self._showChooseStoreButton();
			}
			self._initMoreStores();
			self._attachHandlersToRenderedElements();
			if(FindInStoreConfig.altColorsEnabled){
				_renderAltColors(findInStoreData);	
			}
			
			$.pubsub('publish', 'find-in-store.templated-rendered');
		});
	};

	self._initMoreStores = function(){
		var numResults = $('.store-results-list').find('section').length;
		
		if(numResults > 4){
			$('.additional-stores-button-js').removeClass('hidden');	
		}
	};	

	self._setSelectedStore = function(){
		if ( FindInStoreConfig.mobileResultsCollapsed && screenSize.size() === 'small' ){
			return;
		}
		$('.find-in-store-accordion')
			.find('.store-result-js')
				.first()
				.addClass('opened');
	};

	self._attachHandlersToRenderedElements = function(){		
		$( ".accordion_js .store-title_js" ).on("click", self._sectionTitleClickHandler );
		$( ".accordion_js .store-title_js" ).on("keydown", function (e) {
			var keycode = e.keyCode || e.which;
			if(keycode == 13) {
				self._sectionTitleClickHandler(e);
			}
		});
	
		$('.additional-stores-button-js').on('click', self._showAdditionalStores );
		$('.find-the-stock-js').on('click', self._showSection );	
		$('.buttonchooseID').on('click', function(event) {
			self._updateCookieValue.call(this);
			self._updateYourStoreText.call(this);
			event.stopPropagation();
		});
	};
		
	self._updateCookieValue = function(){		
		var favCookieName = WCS_CONFIG.get("BOPIS::bopisFavStore") + ctx.getStoreId();
		ctx.setCookie(favCookieName,this.attributes[1].nodeValue);
		ctx.setCookie("STORE_ZIP_VALUE",this.attributes[2].nodeValue);
	};
		
	self._updateYourStoreText = function() {
		var setStore = $(this).attr('data-retail-store-number');
		var yourStoreText = LANG_FIND_IN_STORE.RETAIL_STORE_INVENTORY_YOUR_STORE;
		$('.bopis-your-store').html('');
		$('.buttonchooseID').removeClass('hide');
		$('span[data-retail-store-number='+setStore+']').html(yourStoreText);
		$('label[data-retail-store-number='+setStore+']').addClass('hide');
	};		
			
	self._showSection = function() {
		var pdpInstoreFilterShowInstockOnly = WCS_CONFIG.get("PDP::pdpInstoreFilterShowInstockOnly");
		var divs = document.getElementsByClassName("store-result-js");
		if ($(this).is(':checked')) {
			$('.store-result-js').each(function(i){
				var availabilityState = ($(this).data('availability-state')) ? $(this).data('availability-state') : 'OUT_OF_STOCK';
				var shouldAddHideClass = ["OUT_OF_STOCK", "OTHER_COLORS_AVAILABLE"].indexOf(availabilityState) !== -1 || (pdpInstoreFilterShowInstockOnly && availabilityState === "IN_STOCK_IN_DC");
				if ( shouldAddHideClass ) {
					$(this).addClass('hide');
				} else {
					$(this).removeClass('hide');
				}
			});	 
		} else {
			$('.store-result-js').removeClass('hide');
		}
	};
	
	self._showChooseStoreButton = function(){
		var buttonchoose = document.getElementsByClassName("fav-store");
		var divs = document.getElementsByClassName("store-result-js");
		var chooseStoreButtonInPopUp = LANG_FIND_IN_STORE.RETAIL_STORE_INVENTORY_STORE_CHOOSE_BUTTON;
		var stockAvailability = LANG_FIND_IN_STORE.RETAIL_STORE_INVENTORY_OUT_OF_STOCK;
		var storeValue = LANG_FIND_IN_STORE.RETAIL_STORE_INVENTORY_YOUR_STORE;
		var valueinappend = $('.append-value-js');
		$('.buttonchooseID').each(function(index) {
			if((divs[index].innerText.indexOf(stockAvailability) >= 0)) {
				$(this).addClass('out-of-stock');
			}
			else if(valueinappend[index].innerText === storeValue) {
				$(this).addClass('hide');
			}
		}); 		
	};
	
	self._showStoreCheckBox = function(){
		 $('.store-availability-filter').removeClass('hide');
		 if(WCS_CONFIG.get("PDP::w2gifilterOOSStores")){
			 $('.store-availability-filter, .bopis-filter').removeClass('hidden');
		 }
	};

	self._sectionTitleClickHandler = function(event){
		var target = $( event.target ),
			target_parent = target.closest('section'),
			$openItem = target
				.parents('.accordion_js')
				.find('.store-result-js.opened'),
			isROBIS = WCS_CONFIG.get('PDP::ROBISEnabled');

		if (isROBIS) {
			$openItem.find('.robis-reserve-button-js').removeClass('hide');
			$openItem.find('.robis-reserve-form-wrapper-js').remove();
		}

		if(!target_parent.hasClass('opened')){
			if (isROBIS) {
				$openItem.removeClass('opened');
			}
			target_parent.addClass('opened');
		} else {
			target_parent.removeClass('opened');
		}    
	};

	self._showAdditionalStores = function(event){	 
		$visibleStores = $('.store-result-js.initial');
		$hiddenStores  = $('.store-result-js.hidden');

		if($('.additional-stores-button-js').hasClass('show-more')){
			
			$hiddenStores
				.addClass('additional-visible')
				.removeClass('hidden');

			$('.additional-stores-button-js')
				.removeClass('show-more')
				.addClass('show-less')
				.html(LANG_FIND_IN_STORE.RETAIL_STORE_MORE_BUTTON_TEXT_EXPANDED + '<span class="icon"></span>');

			self._showVisibleCount();
			
		}else if($('.additional-stores-button-js').hasClass('show-less')){
			
			$('.additional-stores-button-js')
				.removeClass('show-more')
				.addClass('show-less')
				.html(LANG_FIND_IN_STORE.RETAIL_STORE_MORE_BUTTON_TEXT_EXPANDED + '<span class="icon"></span>');

			$('.store-result-js.additional-visible')
				.addClass('hidden')
				.removeClass('opened');

			$('.additional-stores-button-js')
				.removeClass('show-less')
				.addClass('show-more')
				.html(LANG_FIND_IN_STORE.RETAIL_STORE_MORE_BUTTON_TEXT_COLLAPSED + '<span class="icon"></span>');
			
			self._showVisibleCount();	
			
		}
		
	};

	self._showVisibleCount = function(){
		numVisibleStores = $('.store-result-js').not('.hidden').length;
		$('.num-visible-js').html(numVisibleStores);

		if (WCS_CONFIG.get('PDP::ROBISEnabled')) {
			var $storeResultsNum = $('.num-store-results-js');
			if (!$storeResultsNum.hasClass('hide')) {
				$storeResultsNum.addClass('hide');
			}

			var locationText = (
				findInStoreDataLocationType === 'user-location' ?
					LANG_FIND_IN_STORE.ROBIS_USER_LOCATION :
					$('.in-store-availability-search-input-js').val()
			);

			$('.find-store-result-title > h4').text(numVisibleStores + ' '+ LANG_FIND_IN_STORE.ROBIS_RESULTS +' ' + locationText);
		}
	};
	
	

	return self.render;
	
}());


return {
	renderData : init
};

});
